import { CellContextInsertDynamicLabel, CellContextInsertNRowsAboveAction, CellContextInsertNRowsBelowAction, CellContextPasteAction, isHeaderRow, shouldHideInsertRows, } from './Spreadsheet.utils';
import { CellContextIconOptionRenderer } from './components/ContextMenuOption/ContextMenuOption';
export const CellContextMenu = (rowLimit) => ({
    items: {
        copy: {
            name: 'Copy',
            renderer: CellContextIconOptionRenderer('content_copy'),
        },
        paste: {
            name: 'Paste',
            callback: CellContextPasteAction,
            renderer: CellContextIconOptionRenderer('content_paste'),
        },
        insertNRowsBelow: {
            name: CellContextInsertDynamicLabel('below', rowLimit),
            callback: CellContextInsertNRowsBelowAction(rowLimit),
            renderer: CellContextIconOptionRenderer('add'),
            hidden: shouldHideInsertRows(rowLimit),
        },
        insertNRowsAbove: {
            name: CellContextInsertDynamicLabel('above', rowLimit),
            callback: CellContextInsertNRowsAboveAction(rowLimit),
            renderer: CellContextIconOptionRenderer('add'),
            hidden: shouldHideInsertRows(rowLimit),
        },
        remove_row: {
            name: 'Delete row',
            renderer: CellContextIconOptionRenderer('delete'),
            hidden: isHeaderRow,
        },
    },
});
//# sourceMappingURL=Spreadsheet.constants.js.map